import React from 'react';

import UnloadWithForkliftView from './UnloadWithForkliftView';
import UnloadWithConveyorView from './UnloadWithConveyorView';
import UnloadManuallyView from './UnloadManuallyView';
import UnloadingWithMachineView from './UnloadWithMachineView';

const UnloadView = (props) => {
  const { variant, isForklift, isConveyor } = props;

  if (isForklift || isConveyor) {
    if (variant === 'v2') {
      return (<UnloadingWithMachineView {...props} />)
    } else {
      if (isForklift) {
        return (<UnloadWithForkliftView {...props} />);
      }

      if (isConveyor) {
        return (<UnloadWithConveyorView {...props} />);
      }
    }
  }


  return (<UnloadManuallyView variant={variant} {...props} />);
};

export default UnloadView;